export const checkIsInViewport = (element: HTMLElement, offset = 0) => {
  const rect = element.getBoundingClientRect();

  return (
    rect.top - offset >= 0 &&
    rect.left - offset >= 0 &&
    rect.right + offset <=
      (element.ownerDocument.documentElement.clientWidth ||
        window.innerWidth) &&
    rect.bottom + offset <=
      (element.ownerDocument.documentElement.clientHeight || window.innerHeight)
  );
};
